import api from '../services/api';

const ComunicacionModel = {
    // Obtener historial de comunicaciones
    getAll: async () => {
        try {
            const response = await api.get('/comunicaciones');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo comunicaciones:', error);
            return [];
        }
    },

    // Enviar nueva comunicación
    send: async (data) => {
        try {
            const response = await api.post('/comunicaciones', data);
            return response.data;
        } catch (error) {
            console.error('Error enviando comunicación:', error);
            throw error;
        }
    },

    // Obtener estadísticas
    getStats: async () => {
        try {
            const response = await api.get('/comunicaciones/stats');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo estadísticas:', error);
            return {
                total_enviados: 0,
                tasa_apertura: '0%',
                tasa_click: '0%',
                clientes_suscritos: 0
            };
        }
    }
};

export default ComunicacionModel;